import styled from "@emotion/styled";

export const SeeAllButton = styled.button`
  padding: ${({ theme }) => theme.spacing["2"]};
  padding-left: ${({ theme }) => theme.spacing["3"]};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;

export const SectionListTitleWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing["2"]};
`;
